export const SCORE_THRESHOLDS = { high: 75, medium: 50 } as const;

// Flotion cartographic score scale — mint / amber / coral (see brand palette).
export const SCORE_HEX = {
  high: "#2e9f70",
  medium: "#c97d2d",
  low: "#c75c5c",
  none: "#a8a59c",
} as const;

export const SCORE_CLASSES = {
  high: "text-[#2e9f70]",
  medium: "text-[#c97d2d]",
  low: "text-[#c75c5c]",
} as const;

export function scoreLevel(score: number): "high" | "medium" | "low" {
  if (score >= SCORE_THRESHOLDS.high) return "high";
  if (score >= SCORE_THRESHOLDS.medium) return "medium";
  return "low";
}

export function scoreHex(score: number | null | undefined): string {
  if (score == null) return SCORE_HEX.none;
  return SCORE_HEX[scoreLevel(score)];
}
